import Steps from "./Steps"
import React, { useEffect, useState } from "react"
import Details from "./Details"

const DescriptionPanel = props => {
  const [tabPill, changeTabPill] = useState("steps")
  const [stepsClassName, changeStepsClassName] = useState("nav-link active")
  const [detailsClassName, changeDetailsClassName] = useState("nav-link")

  return (
    <div>
      <ul className="nav nav-tabs">
        <li className="nav-item">
          <a
            className={stepsClassName}
            href="#"
            onClick={() => {
              changeTabPill("steps")
              changeDetailsClassName("nav-link")
              changeStepsClassName("nav-link active")
            }}
          >
            Steps
          </a>
        </li>
        <li className="nav-item">
          <a
            className={detailsClassName}
            href="#"
            onClick={() => {
              changeTabPill("details")
              changeDetailsClassName("nav-link active")
              changeStepsClassName("nav-link")
            }}
          >
            Detailed Description
          </a>
        </li>
      </ul>
      {tabPill === "steps" ? (
        <Steps
          type={props.detailsType}
          processingTime="30"
          licenseValidity="NA"
        />
      ) : (
        <Details type={props.detailsType} />
      )}
    </div>
  )
}

export default DescriptionPanel
